import { render, staticRenderFns } from "./memoList.vue?vue&type=template&id=0245ae20&scoped=true&"
import script from "./memoList.vue?vue&type=script&lang=js&"
export * from "./memoList.vue?vue&type=script&lang=js&"
import style0 from "./memoList.vue?vue&type=style&index=0&id=0245ae20&scoped=true&lang=css&"
import style1 from "./memoList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0245ae20",
  null
  
)

export default component.exports